export enum ProductActionTypes {
    UPDATE_PRODUCT,
    ADD_IMAGE,
    DELETE_IMAGE,
    UPDATE_NOTES,
    UPDATE_DOCUMENT,
    DELETE_PRODUCT,
}
